export function formatEnum(val: string | undefined | null): string {
  if (!val) return '';
  return val.split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

export interface MonthlyPriceLike {
  amount: string | number;
  currency: string;
  period?: string;
  tax?: string;
}

/**
 * Formats a monthly net list price in its currency for display, e.g. "€3.29 net" or "$24.00 net".
 * Returns an empty string when price data is missing/invalid.
 */
export function formatMonthlyNetPrice(
  price: MonthlyPriceLike | null | undefined
): string {
  if (!price) return '';
  const amount = typeof price.amount === 'number' ? price.amount : Number(price.amount);
  if (!Number.isFinite(amount)) return '';
  const currency = (price.currency || 'EUR').toUpperCase();
  const formatted = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
  const tax = price.tax || 'net';
  return `${formatted} ${tax}`;
}

/**
 * Tooltip / title text for a monthly net list price.
 * Accepts either a price object or an already-formatted price string.
 */
export function monthlyNetPriceTitle(
  priceOrFormatted: MonthlyPriceLike | string | null | undefined,
  source = 'Hetzner Cloud'
): string {
  const formatted =
    typeof priceOrFormatted === 'string'
      ? priceOrFormatted
      : formatMonthlyNetPrice(priceOrFormatted);
  return formatted
    ? `${source} monthly net list price: ${formatted}`
    : 'Monthly price unavailable';
}
